import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const RightPanelInvertedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-870 -69) translate(858 51) translate(0 12)">
                        <g>
                            <path
                                d="M0 0L18 0 18 18 0 18z"
                                transform="translate(12 6)"
                            />
                            {/* Explicit, because fill is inherited from the
                                nearest ancestor that sets it -- the g above
                                with fill="none" -- and not from SvgIcon's own
                                style on the svg element. */}
                            <path
                                fill="currentColor"
                                d="M15.25 2.25c1.105 0 2 .895 2 2v9.5c0 1.105-.895 2-2 2H2.75c-1.105 0-2-.895-2-2v-9.5c0-1.105.895-2 2-2h12.5zm.5 1.5H2.25v10.5h13.5V3.75zm-1.5 1.5v7.5h-3v-7.5h3z"
                                transform="translate(12 6)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default RightPanelInvertedIcon;
